var site = site || {};
var generic = generic || {};
var prodcat = prodcat || {};
// Defining SmartGift variables.
var SmartGiftWidget = SmartGiftWidget || {};
var SGBasket = SGBasket || {};

(function ($) {
  Drupal.behaviors.productSmartGiftV1 = {
    attach: function (context) {
      var $smartGift = $('.js-product-smart-gift-v1', context);
      var $smartGiftCta = $('.js-product-smart-gift-cta', $smartGift);
      var $smartGiftToolTip = $('.js-product-smart-gift-tooltip', $smartGift);
      var $productContainer;
      var self = this;

      if (self.attached || typeof Drupal.settings.smart_gift === 'undefined') {
        return;
      }
      self.attached = true;

      self.loadSmartGiftApi(context);

      $smartGiftToolTip.once().on('click', function (e) {
        e.preventDefault();
        if (
          typeof site.templates !== 'undefined' &&
          typeof site.templates.product_smart_gift_overlay !== 'undefined'
        ) {
          self.showSmartGiftOverlay($smartGiftCta);
        }
      });

      $smartGiftCta.once().on('click', function (e) {
        e.preventDefault();
        $productContainer = $(this).closest('.js-product');
        self.addItemToSmartGiftBasket($productContainer);
      });

      self.initSmartGiftAnalytics();
    },

    loadSmartGiftApi: function (context) {
      var smartGiftApiLink = Drupal.settings.smart_gift.api_link;
      var smartGiftMerchantId = Drupal.settings.smart_gift.merchant_id;

      if ($('script[src="' + smartGiftApiLink + '"]', context).length) {
        return;
      }

      // Vendor's script added per API document.
      (function (d, g, e, c, t, s) {
        t = d.createElement(g);
        t.async = 1;
        t.src = e;
        t.onload = function () {
          SmartGiftWidget.mount(c);
        };
        s = d.getElementsByTagName(g)[0];
        s.parentNode.insertBefore(t, s);
      })(document, 'script', smartGiftApiLink, smartGiftMerchantId);
    },

    showSmartGiftOverlay: function ($smartGiftCta) {
      var smartGiftOverlayTempalte = 'product_smart_gift_overlay';
      var isMobile = Unison.fetch.now().name === 'small';
      var maxWidth = '550px';
      var maxHeight = isMobile ? '475px' : '430px';
      var smartGiftContent = site.template.get({ name: smartGiftOverlayTempalte });

      generic.overlay.launch({
        html: smartGiftContent,
        className: 'product-smart-gift-overlay__colorbox',
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        includeCloseLink: true
      });
    },

    addItemToSmartGiftBasket: function ($productContainer) {
      var productId = $productContainer.data('product-id');
      var skuId = $productContainer.data('sku-base-id');
      var productData = prodcat.data.getProduct(productId);

      if (!!productData && productData.shaded) {
        skuId = $productContainer
          .find('.active.js-product-full-shades-grid-item')
          .data('sku-base-id');
      }
      var skuData = prodcat.data.getSku(skuId);
      var pageUrl = window.location.href;
      var parsedProductName;
      var smartGiftData;

      if (productData === null || skuData === null) {
        return;
      }
      parsedProductName = $($.parseHTML(productData.PROD_RGN_NAME)).text();
      smartGiftData = {
        skuCode: skuData.SKU_BASE_ID,
        skuUrl: pageUrl,
        price: skuData.PRICE,
        name: parsedProductName,
        image: skuData.IMAGE_MEDIUM_COMBINED && skuData.IMAGE_MEDIUM_COMBINED[0]
      };
      SGBasket.addItem(smartGiftData);
    },

    initSmartGiftAnalytics: function () {
      var self = this;
      var smartGiftCta = '.js-product-smart-gift-cta';
      var smartGiftTooltip = '.js-product-smart-gift-tooltip';
      var seeGiftCta = '.SGBasket-widget .widget-footer-gotItButton';
      var prepareGiftCta = '.SGBasket-widget .widget-summary-button';
      var cancelGiftCta = '.SGBasket-widget .widget-footer-cancelGift';
      var smartGiftToggleButton = '.SGBasket-widget .SGBasketButton';
      var smartGiftCloseButton = '.product-smart-gift-overlay__colorbox #cboxClose';
      var $productContainer = $(smartGiftCta).closest('.js-product');
      var productId = $productContainer && $productContainer.data('product-id');
      var smartGiftEventContainers = {
        launch: smartGiftCta,
        'help - open': smartGiftTooltip,
        'see gift': seeGiftCta,
        'prepare my gift': prepareGiftCta,
        'cancel this gift': cancelGiftCta,
        'minimize / maximize': smartGiftToggleButton,
        'help - close': smartGiftCloseButton
      };

      self.addAnalyticsEvent(smartGiftEventContainers, productId);
    },

    addAnalyticsEvent: function (smartGiftEventContainers, productId) {
      var self = this;

      $.each(smartGiftEventContainers, function (eventAction, selector) {
        $(document).on('click', selector, { eventAction: eventAction }, function (e) {
          self.trackEventLink(e.data.eventAction, productId);
        });
      });
    },

    trackEventLink: function (eventAction, productId) {
      var smartGift = 'smartgift';

      site.track.evtLink({
        event_name: smartGift,
        event_category: smartGift,
        event_action: eventAction,
        event_label: productId
      });
    },

    attached: false
  };

  $(document).on('product.skuSelect', '.js-product', function (e, skuId) {
    var skuData;
    var soldOutInventoryStatus;
    var $smartGiftContainer;

    if (typeof Drupal.settings.smart_gift === 'undefined') {
      return;
    }
    skuData = prodcat.data.getSku(skuId);
    soldOutInventoryStatus = 7;
    $smartGiftContainer = $(this).find('.js-product-smart-gift-v1');
    $smartGiftContainer.removeClass('hidden');
    $('.js-replenishment-shaded-wrapper, .js-replenishment-non-shaded-wrapper').removeClass(
      'one-click__without-smart-gift__replenishment'
    );
    $('.js-product-full-ctas-shaded-wrapper, .js-product-full-ctas-non-shaded-wrapper').removeClass(
      'one-click__without-smart-gift'
    );
    if (skuData && skuData.INVENTORY_STATUS === soldOutInventoryStatus) {
      $smartGiftContainer.addClass('hidden');
    }
  });
})(jQuery);
